import axios, { AxiosError } from 'axios';
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { CommonState, error, isFetching } from '@pec/aion-ui-core/slices/common';
import { enqueueRequestErrorSnackbar } from '@pec/aion-ui-core/actions/enqueueSnackbar';

const name = 'contractorIncidentReportInfo';

export type ContractorIncidentReportInfo = {
  automationId: string;
  clientOrganizationId: string;
};

export const fetchContractorIncidentReportInfo = createAsyncThunk(
  `${name}/fetch`,
  async (contractorId: string, { dispatch }) => {
    try {
      const url = `/api/processautomation/v1.0/contractors/${contractorId}/incident-report-info`;
      const response = await axios.get<ContractorIncidentReportInfo>(url);
      return response.data ?? null;
    } catch (err) {
      // 404 is the expected "no access" response, not a failure
      const axiosError = err as AxiosError;
      if (axiosError.response?.status === 404) {
        return null;
      }
      dispatch(enqueueRequestErrorSnackbar());
      throw err;
    }
  }
);

export type State = CommonState & {
  hasAccess: boolean;
  automationId: string | null;
  clientOrganizationId: string | null;
};

const initialState: State = {
  hasAccess: false,
  automationId: null,
  clientOrganizationId: null,
  isFetching: false,
  error: null
};

const contractorIncidentReportInfo = createSlice({
  name,
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder
      .addCase(fetchContractorIncidentReportInfo.pending, isFetching)
      .addCase(fetchContractorIncidentReportInfo.fulfilled, (state, action) => {
        state.hasAccess = action.payload !== null;
        state.automationId = action.payload?.automationId ?? null;
        state.clientOrganizationId = action.payload?.clientOrganizationId ?? null;
        state.isFetching = false;
      })
      .addCase(fetchContractorIncidentReportInfo.rejected, error);
  }
});

export const { reducer: contractorIncidentReportInfoReducer } = contractorIncidentReportInfo;
